import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { PrFormSelectListComponent } from '@app/components/pr-form/pr-form-select-list/pr-form-select-list.component';
import { PrSubformComponent } from '@app/components/pr-form/pr-subform/pr-subform.component';
import { PrTableFormComponent } from '@app/components/pr-form/pr-table-form/pr-table-form.component';
import { PrTableColumn } from '@app/components/pr-table/pr-table.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { API_ROUTE_SUPPORTS_SEARCH } from '@app/forms/subscription/api/api-router';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { Observable, Subject, combineLatest, debounceTime, map, mergeMap, tap } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'investissement-support',
    templateUrl: './investissement-support.component.html',
    styleUrls: ['./investissement-support.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class InvestissementSupportComponent implements OnInit, AfterViewInit {
  @Input() derrors;
  supports: any[] = [];
  supportTypes;
  supportsLength = 0;
  supportsPageSize = 15;
  currentPage = 0;
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();

  callback: any;
  entity: any = {};
  // criteriaForm: FormGroup;

  @ViewChild('tableForm', { static: true }) tableForm: PrTableFormComponent;
  @ViewChild('supportsForm', { static: true }) supportsForm: PrSubformComponent;
  @ViewChild('formSelectList', {
    static: true,
    read: PrFormSelectListComponent,
  })
  formSelectList: PrFormSelectListComponent;

  columnsDefinition = [
    new PrTableColumn('Noms des supports', 'name', { span: 3 }),
    new PrTableColumn('Repartition', 'repartitionPercent', 'input', {
      changeCallback: this.tableAllocationColumnValueChanged.bind(this),
      suffix: '%',
      span: 2,
    }),
    new PrTableColumn('Montant investi', 'investedAmount', 'currency', {
      span: 2,
    }),
    new PrTableColumn('', 'action', 'action'),
  ];
  criteriaForm: UntypedFormGroup;
  selectedType = undefined;
  productId: any;
  constructor(
    private controlContainer: FormGroupDirective,
    private httpApi: HttpApiService,
    private referenceDao: ReferenceDao,
    protected formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    this.criteriaForm = this.formBuilder.group({
      autocomplete: [],
      supportTypes: [],
    });
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }

  ngOnInit(): void {
    this.productId =
      this.subscriptionFacade.getPledge()?.products[0]?.productId;
    this.formSelectList.loading = true;

    this.supportTypes = combineLatest([
      this.referenceDao.getSupportTypes(),
      this.search(),
    ]).pipe(
      map(([supportTypes, search]) => supportTypes),
      tap(data => {
        // this.criteriaForm.get("supportTypes").setValue("REALESTATE_FOUND");
      }),
    );

    this.criteriaForm.valueChanges
      .pipe(
        untilDestroyed(this),
        tap(() => (this.formSelectList.loading = true)),
        debounceTime(500),
        mergeMap(this.search.bind(this)),
      )
      .subscribe();
  }
  createModel(item) {
    let model = {
      id: [item ? item.id : null],
      isin: [item ? item.isin || item.supportIsin : null],
      index: [item ? item.index : null],
      omniprodId: [item ? item.omniProductId || item.omniprodId : null],
      name: [item ? item.name : null],
      repartitionPercent: [item ? item.repartitionPercent : null],
      monthlyRepartition: [item ? item.monthlyRepartition : null],

      favorite: [item ? item.favorite : null],
      type: [item ? item.type : null],
      supportDescription: [null],
      totalInvestedAmount: [null],
    };
    return model;
  }

  changeSupportsPage(event) {
    this.currentPage = event.pageIndex;
    this.formSelectList.loading = true;
    this.search().subscribe();
  }

  search(): Observable<any> {
    return this.httpApi
      .post(API_ROUTE_SUPPORTS_SEARCH, {
        page: this.currentPage + 1,
        size: this.supportsPageSize,
        autocomplete: this.criteriaForm.value.autocomplete,
        supportTypes: this.criteriaForm.value.supportTypes
          ? [this.criteriaForm.value.supportTypes]
          : undefined,
        productId: this.productId,
        fillFullData: true,
        noStrike: true,
        active: true,
      })
      .pipe(
        untilDestroyed(this),
        map(res => {
          this.formSelectList.loading = false;
          this.supportsLength = res.totalElements;
          this.supports = res.content;
          return res;
        }),
        tap(() => this.cdr.detectChanges()),
      );
  }

  _defaultAllocationFormValue: any;
  onSupportSelect(support) {
    let newControl = this.formBuilder.group(this.createModel(support));
    let formArray = this.form.controls
      .avOptionInvestissementProgressifRepartition as UntypedFormArray;
    newControl.setValue({ ...newControl.value, index: formArray.value.length });
    formArray.push(newControl);
    // set parent form as dirty
    this.form.markAsDirty();
  }

  onSupportDeselect(support) {
    let formArray = this.form.controls
      .avOptionInvestissementProgressifRepartition as UntypedFormArray;
    let control = formArray.controls.findIndex(
      c => c.value.id == support.id || c.value.isin == support.isin,
    );
    formArray.removeAt(control);
    this.form.markAsDirty();
  }

  tableAllocationColumnValueChanged(value: any, row: any, column: any) {
    this.avOptionInvestissementProgressifRepartition.controls[
      row.index
    ].setValue({
      ...this.avOptionInvestissementProgressifRepartition.controls[row.index]
        .value,
      [column.name]: value / 100,
    });
    this.markAsDirtyTouchedAndRefresh(row.index);
  }

  cancelManageAllocationform() {
    this.entity =
      this._defaultAllocationFormValue.avOptionInvestissementProgressifRepartition;
    //this.generate(this.entity, this.options);
    this._defaultAllocationFormValue = [];
  }

  validManageAllocationform() {
    let formArray = this.form.controls
      .avOptionInvestissementProgressifRepartition as UntypedFormArray;
    this.tableForm.initTable();
    this._defaultAllocationFormValue = [];
  }

  markAsDirtyTouchedAndRefresh(control) {
    this.avOptionInvestissementProgressifRepartition.controls[
      control
    ].markAsDirty();
    this.avOptionInvestissementProgressifRepartition.controls[
      control
    ].markAsTouched();
    this.tableForm.initTable();
  }

  formatTableDataFunction() {
    return data =>
      _(data)
        .map((data, i) => {
          return {
            index: i,
            name: data.name,
            repartitionPercent: data.repartitionPercent * 100,
            investedAmount: data.totalInvestedAmount * data.repartitionPercent,
            totalInvestedAmount: data.totalInvestedAmount,
          };
        })
        .value();
  }

  newOptionLogic() {
    //First element at 100%
    if (+this.avOptionInvestissementProgressifRepartition.controls.length == 1)
      return this.avOptionInvestissementProgressifRepartition.controls[0].setValue(
        {
          ...this.avOptionInvestissementProgressifRepartition.controls[0].value,
          repartitionPercent: 1,
          shareCount: this.avOptionInvestissementProgressifRepartition
            .controls[0].value.partPrice
            ? Math.round(
                this.avOptionInvestissementProgressifRepartition.controls[0]
                  .value.totalInvestedAmount /
                  this.avOptionInvestissementProgressifRepartition.controls[0]
                    .value.partPrice,
              )
            : '',
        },
      );

    // Form untouched = even allocation
    if (!this.avOptionInvestissementProgressifRepartition.dirty) {
      this.avOptionInvestissementProgressifRepartition.controls[0].setValue({
        ...this.avOptionInvestissementProgressifRepartition.controls[0].value,
        repartitionPercent: 0,
      });

      //Ignore first control in order to set the missing allocation percent inside
      _.forEach(
        this.avOptionInvestissementProgressifRepartition.controls,
        (c, i) =>
          +i != 0
            ? c.setValue({
                ...c.value,
                repartitionPercent: this.floored(
                  1 /
                    +this.avOptionInvestissementProgressifRepartition.controls
                      .length,
                ),
                shareCount: c.value.partPrice
                  ? Math.round(
                      (this.floored(
                        1 /
                          +this.avOptionInvestissementProgressifRepartition
                            .controls.length,
                      ) *
                        c.value.totalInvestedAmount) /
                        c.value.partPrice,
                    )
                  : '',
              })
            : null,
      );

      let allocationLeft =
        this.totalAllocatedPercent < 1
          ? this.floored(1 - this.totalAllocatedPercent)
          : this.floored(this.totalAllocatedPercent - 1);
      this.avOptionInvestissementProgressifRepartition.controls[0].setValue({
        ...this.avOptionInvestissementProgressifRepartition.controls[0].value,
        repartitionPercent: allocationLeft,
        shareCount: this.avOptionInvestissementProgressifRepartition.controls[0]
          .value.partPrice
          ? Math.round(
              (allocationLeft *
                this.avOptionInvestissementProgressifRepartition.controls[0]
                  .value.totalInvestedAmount) /
                this.avOptionInvestissementProgressifRepartition.controls[0]
                  .value.partPrice,
            )
          : '',
      });
      return;
    }

    // Allocation < 1 = set value left to the control
    if (this.totalAllocatedPercent < 1) {
      let newControl =
        this.avOptionInvestissementProgressifRepartition.controls[
          this.avOptionInvestissementProgressifRepartition.value.length - 1
        ];
      return newControl.setValue({
        ...newControl.value,
        repartitionPercent: 1 - this.totalAllocatedPercent,
        shareCount: this.avOptionInvestissementProgressifRepartition.controls[
          this.avOptionInvestissementProgressifRepartition.value.length - 1
        ].value.partPrice
          ? Math.round(
              ((1 - this.totalAllocatedPercent / 100) *
                this.avOptionInvestissementProgressifRepartition.controls[
                  this.avOptionInvestissementProgressifRepartition.value
                    .length - 1
                ].value.totalInvestedAmount) /
                this.avOptionInvestissementProgressifRepartition.controls[
                  this.avOptionInvestissementProgressifRepartition.value
                    .length - 1
                ].value.partPrice,
            )
          : '',
      });
    }
  }

  openSupportsForm() {
    this.supportsForm.open();
  }

  onSubmit() {
    this.derrors = true;

    // stop here if form is invalid
    if (this.form.invalid || this.totalAllocatedPercent != 1) {
      return;
    }

    this.doneSubject.next();
    if (this.callback) {
      // this.callback(this.extract());
    }
  }

  floored(value) {
    return Math.round(value * 100) / 100;
  }

  get avOptionInvestissementProgressifRepartition() {
    return this.form.get(
      'avOptionInvestissementProgressifRepartition',
    ) as UntypedFormGroup;
  }

  get totalAllocatedPercent() {
    return this.floored(
      _(this.avOptionInvestissementProgressifRepartition.value)
        .map('repartitionPercent')
        .sum(),
    );
  }
  get allocationPanel() {
    if (
      !this.avOptionInvestissementProgressifRepartition ||
      !this.avOptionInvestissementProgressifRepartition.value ||
      this.avOptionInvestissementProgressifRepartition.value.length == 0
    )
      return {
        display: 'info',
        icon: 'info',
        text: 'Renseignez vos investissements',
      };
    else if (this.totalAllocatedPercent > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          this.totalAllocatedPercent * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% de l'investissement`,
      };
    else if (this.totalAllocatedPercent < 1)
      return {
        display: 'warning',
        icon: 'warning',
        text: `Il reste ${Math.round(
          this.form.get('avOptionInvestissementProgressifRepartition').value[0]
            .totalInvestedAmount *
            (1 - this.totalAllocatedPercent),
        )}€ de votre investissement à répartir, soit ${Math.round(
          (1 - this.totalAllocatedPercent) * 100,
        )}%`,
      };
    else if (
      _.filter(
        this.avOptionInvestissementProgressifRepartition.value,
        scpi => !scpi.repartitionPercent,
      ).length
    )
      return {
        display: 'danger',
        icon: 'error',
        text: 'Vous ne pouvez pas repartir 0% dans un support',
      };
    else if (this.totalAllocatedPercent == 1)
      return {
        display: 'success',
        icon: 'check',
        text: 'Félicitations, vos investissements sont répartis à 100%',
      };
  }

  onMoreInfoClick(support) {
    window.open(`#/dashboard/assets/supports/${support.id}`, '_blank');
  }
}
